import React from 'react'
import Link from 'gatsby-link'

const Pay = () => (
  <div className="container">
    <h1>Pay</h1>
    <br />
    <Link to="/">Go back to the homepage</Link>
  </div>
)

export default Pay



// WEBPACK FOOTER //
// ./src/pages/pay.js